<template>
  <ModalConfirmation
    :class="$style.headerFontSize"
    :showModal="true"
    :title="header"
  >
    <template v-slot:body>
      <ParagraphBody>
        <div v-if="body.length">
          <div
            v-for="text in body"
            :key="text"
          >
            <MarkdownInline :mdTemplate="text" />
          </div>
        </div>
        <HeadingExtraSmall :class="$style.headingMargin">
          {{ inputLabel }}
        </HeadingExtraSmall>
        <InputText
          v-model="newPassword"
          :class="$style.inputBox"
          rules="required|min:8"
          showValidationMessage
          @input="value => handlePasswordInput(value)"
        />
      </ParagraphBody>
    </template>
    <template v-slot:footer>
      <ButtonGroupSave
        :isDisabledPrimary="isSaveDisabled"
        :isFullWidth="false"
        :primaryButtonProps="primaryButtonProps"
        :secondaryButtonProps="secondaryButtonProps"
        @primaryAction="handleAction"
        @secondaryAction="handleClose"
      />
    </template>
  </ModalConfirmation>
</template>

<script>
import * as Constants from 'client/util/Constants';
import {
  ButtonGroupSave,
  HeadingExtraSmall,
  InputText,
  MarkdownInline,
  ModalConfirmation,
  ParagraphBody,
  Types,
} from '@jumpcloud/ui-components';
import { notify } from 'client/util';
import ModalEventBus from 'client/components/Modal/ModalEventBus';

const { error, success } = Constants.default;
const { PrimaryButtonProps, SecondaryButtonProps } = Types;

export default {
  name: 'SystemEmmCommandsPasscodeModal',

  components: {
    ButtonGroupSave,
    HeadingExtraSmall,
    InputText,
    MarkdownInline,
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    actionEvent: {
      required: true,
      type: String,
    },
    actionText: {
      required: true,
      type: String,
    },
    body: {
      required: true,
      type: Array,
      default: () => [],
    },
    emmApiAction: {
      required: true,
      type: Function,
    },
    header: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
    inputLabel: {
      required: true,
      type: String,
    },
    onSuccess: {
      required: true,
      type: String,
    },
  },

  data: () => ({
    flags: ['LOCK_NOW'],
    isComplete: false,
    newPassword: '',
    isSaveDisabled: true,
  }),

  computed: {
    primaryButtonProps() {
      return PrimaryButtonProps({ text: this.actionText });
    },

    secondaryButtonProps() {
      return SecondaryButtonProps({ text: 'cancel' });
    },
  },

  methods: {
    handleAction() {
      this.emmApiAction(this.id, { flags: this.flags, newPassword: this.newPassword })
        .then(() => {
          ModalEventBus.$emit(this.actionEvent);
          if (this.onSuccess.length > 0) notify(success, this.onSuccess);
        })
        .catch(() => {
          notify(error, 'An error occurred while attempting to perform this action.');
        })
        .finally(() => {
          ModalEventBus.close();
        });
    },

    handleClose() {
      ModalEventBus.close();
    },

    handlePasswordInput(value) {
      this.isSaveDisabled = value.length < 8;
    },
  },
};
</script>

<style module>
.headerFontSize div div header h3 {
  font-size: var(--jcHeadingSmall) !important;
}

.headingMargin {
  margin-bottom: var(--jc-spacer-x-small) !important;
  margin-top: var(--jc-spacer-large) !important;
}

.inputBox {
  margin-bottom: 0;
}

.inputBox span {
  display: none;
}
</style>
